import { render, staticRenderFns } from "./DirList.vue?vue&type=template&id=59af3447"
import script from "./DirList.vue?vue&type=script&lang=js"
export * from "./DirList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports